import styled from 'styled-components';
import { colours, fonts } from 'themes/default';

const { fontFamily } = fonts;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  margin-right: 8px;
`;

export const SubtitleContainer = styled.p`
  font-size: 16px;
`;

export const StyledWarningCtaMultiplePFSpan = styled.span`
  display: block;
`;

export const StyledPF = styled.span`
  font-weight: bold;
`;
export const StyledMixedJourneyContainer = styled.div`
  display: flex;
  margin-bottom: 5px;
`;

export const StyledMixedJourney = styled(StyledPF)`
  margin-right: 10px;
  color: ${colours.Core.SecondaryRed};
`;

export const StyledContainerOverflow = styled.p`
  font-family: ${fontFamily};
  font-weight: normal;
  font-size: 16px;
  max-height: 400px;
  overflow-y: scroll;
`;

export const StyledWarningCtaMultiplePF = styled(StyledContainerOverflow)`
  background-color: white;
  padding: 10px;
  font-size: 16px;
`;
